var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import { rootReducer } from "@ane/exp-data/lib/redux/api";
const trafficFilterReducers = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), rootReducer);
export {
  trafficFilterReducers as default,
  trafficFilterReducers
};
//# sourceMappingURL=reducers.js.map
